<template>
  <div>
    <v-data-table
      v-model="itensSelecionados"
      :headers="headers"
      :items="items"
      :search="search"
      fixed-header
      height="calc(100vh - 255px)"
      class="table-full-screen"
      show-select
      item-key="id"
      :items-per-page="-1"
    >
      <template v-slot:top>
        <div class="d-flex py-2 pl-3">
          <v-icon left>mdi-format-list-bulleted</v-icon>
          <p class="mt-3 font-wieght-medium pt-1">
            Tempo de Cobertura por Filiais
          </p>

          <v-spacer />

          <template v-if="itensSelecionados.length > 0">
            <v-badge color="white" overlap class="mr-6">
              <template v-slot:badge>
                <span style="color: #000">{{itensSelecionados.length}}</span>
              </template>

              <v-btn color="error" @click="confirmarDelecao()">
                <v-icon left>mdi-delete</v-icon>
                Excluir
              </v-btn>
            </v-badge>
          </template>

          <template v-else>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Pesquisa"
              dense
              single-line
              hide-details
              clearable
              outlined
              class="pr-4 pl-auto"
              style="max-width: 475px"
            ></v-text-field>
          </template>

          <v-btn class="primary mr-5" @click="dialogCadastroCurvasCompras = ! dialogCadastroCurvasCompras">
            <v-icon left>mdi-plus</v-icon>
            Novo
          </v-btn>

          <dialog-curvas-compras
            v-model="dialogCadastroCurvasCompras"
            :itemParaEdicao="editedItem"
            :itemsSalvos="itemsSalvos"
            @atualizar-lista="buscarItems()"
          ></dialog-curvas-compras>
        </div>
      </template>

      <template #item.data-table-select="{item}">
        <v-btn v-if="!itensSelecionados.includes(item)" icon @click="itensSelecionados.push(item)">
          <v-icon>mdi-checkbox-blank-outline</v-icon>
        </v-btn>

        <v-btn v-else icon @click="itensSelecionados = itensSelecionados.filter(sel => sel !== item)">
          <v-icon>mdi-checkbox-marked</v-icon>
        </v-btn>
      </template>

      <template v-slot:header.action="{item}">
        <div style="margin-left: 9px">Ações</div>
      </template>

      <template v-slot:item.pqr="{item}">
        <template v-if="item.pqr === 'P'">P - Popular</template>
        <template v-else-if="item.pqr === 'Q'">Q - Média</template>
        <template v-else>R - Rara</template>
      </template>

      <template v-slot:item.xyz="{item}">
        <template v-if="item.xyz === 'X'">X - Ordinário</template>
        <template v-else-if="item.xyz === 'Y'">Y - Intermédiario</template>
        <template v-else>Z - Vital</template>
      </template>

      <template v-slot:item.tempo_cobertura="{item}">
        <div class="text-center ml-n15">
          {{ Helpers.formatarValor(item.tempo_cobertura) }} dias
        </div>
      </template>

      <template v-slot:item.action="{item}">
        <v-tooltip top open-delay="600">
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on" @click="editarItem(item)">
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </template>
          <span>Edição de Item</span>
        </v-tooltip>

        <v-tooltip top open-delay="600">
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on" @click="itensSelecionados = [item];confirmarDelecao()">
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </template>
          <span>Exclusão de item</span>
        </v-tooltip>
      </template>
    </v-data-table>

    <DialogConfirmacaoTempoCobertura
      v-model="dialogConfirmacaoExclusao"
      color="red"
      @confirmado="deleteItem()"
    >
      <template #body>
        <p v-text="'Deseja realmente excluir itens selecionados?'" />
      </template>
    </DialogConfirmacaoTempoCobertura>
  </div>
</template>

<script>
import DialogCurvasCompras from "./DialogCurvasCompras.vue"
import TempoCoberturaAPI from "../../../../api/compras/TempoCoberturaPorCurvas"
import DialogConfirmacaoTempoCobertura from "./DialogConfirmacaoTempoCobertura.vue"
import {logout} from "@/helpers";

export default {
  name: 'Cobertura',
  components: {
    DialogCurvasCompras,
    DialogConfirmacaoTempoCobertura
  },
  data: () => ({
    search: "",
    dialogCadastroCurvasCompras: false,
    dialogConfirmacaoExclusao: false,
    itemsSalvos: '',
    headers: [
      { text: 'Id', value: 'id' },
      { text: 'Grupo', value: 'nome_grupo' },
      { text: 'Filial', value: 'filial' },
      { text: 'Usuário', value: 'usuario_log' },
      { text: 'Curva de Popularidade', value: 'pqr' },
      { text: 'Curva de Criticidade', value: 'xyz' },
      { text: 'Tempo de Cobertura', value: 'tempo_cobertura', width: '180px' },
      { text: 'Ações', value: 'action', width: '130px' }
    ],
    editedItem: {},
    items: [],
    itensSelecionados: []
  }),
  watch: {
    dialogCadastro (dialog) {
      !dialog && (this.itensSelecionados = [])
    },
    dialogConfirmacaoExclusao (dialog) {
      !dialog && (this.itensSelecionados = [])
    }
  },
  created() {
    this.buscarItems()
  },
  methods: {
    confirmarDelecao () {
      this.dialogConfirmacaoExclusao = true
    },
    editarItem (item) {
      this.dialogCadastroCurvasCompras = true
      this.editedItem = Object.assign({}, item)
    },
    buscarItems () {
      const headers = this.Helpers.iniciarRequisicao();

      this.$store.dispatch(
        "loading/addRequisicao",
        TempoCoberturaAPI.getListaFull(headers)
          .then((response) => {
            const {token, itens} = response.data;
            localStorage.token = token
            this.items = itens
            this.itemsSalvos = itens;
          })
          .catch(logout)
      );
    },
    deleteItem () {
      const headers = this.Helpers.iniciarRequisicao();
      const ids = this.Helpers.arrayColumn(this.itensSelecionados, 'id')

      this.$store.dispatch(
        "loading/addRequisicao",
        TempoCoberturaAPI.deleteMultiplos(headers, { ids })
          .then((response) => {
            const {token} = response.data;
            localStorage.token = token
            this.buscarItems()
          })
          .catch(logout)
      );
    },
  }
}
</script>

<style>

</style>
